import React, { useState, useEffect, useRef } from 'react';
import styles from './HouseIcon.scss';

export interface IHouseIconProps {
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    isDnz?: boolean;
    isActive?: boolean;
    isExclusive?: boolean;
    isOffMarket?: boolean;
    hasExactLocation?: boolean;
    isCluster?: boolean;
    clusterNr?: number;
}

const HouseIcon: React.FC<React.PropsWithChildren<IHouseIconProps>> = ({
    id = '',
    className = '',
    style = null,
    isDnz = false,
    isActive = false,
    isExclusive = false,
    isOffMarket = false,
    hasExactLocation = false,
    isCluster = false,
    clusterNr = null,
}) => {
    const cn = [
        styles.houseIcon,
        className,
        isDnz ? styles.isDnz : null,
        isActive ? 'active' : null,
        isExclusive ? styles.exclusive : null,
        isOffMarket ? styles.offMarket : null,
        hasExactLocation ? null : styles.noLocation,
        isCluster ? styles.cluster : null,
    ].join(' ');
    return (
        <div className={cn} id={id} style={style}>
            <svg width="25" height="22" viewBox="0 0 155 132" xmlns="http://www.w3.org/2000/svg">
                <rect className="a" height="77" width="108.5" y="52.22656" x="42" />
                <path className="a" d="m44.50748,53.81855l53,-51.49999l53,51.49999l-106.00001,0l0.00001,0z" />
                <path d="m150,47l-46,-44.1l-0.1,-0.2l-0.2,-0.1a10.7,10.7 0 0 0 -5,-1.9l-0.2,0l-41.2,0.8c-6.7,0 -10.2,3 -11.5,4.3l-40.3,40.4a3,3 0 0 1 -0.6,0.5a10.6,10.6 0 0 0 -4,8.2l0,69.9a6.7,6.7 0 0 0 6.7,6.6l139.8,0a6.7,6.7 0 0 0 6.6,-6.6l0,-70a10.3,10.3 0 0 0 -4.2,-7.8l0.2,0zm-110.5,77.7l0,0.3l-32,0a0.2,0.2 0 0 1 -0.3,-0.2l0,-68.8l32.2,-0.3l0.1,69zm2,-75.6l-30.2,0.4l39,-39.2c0.6,-0.6 2.8,-2.4 7,-2.4l28.8,-0.6l-42.1,39.3a10.5,10.5 0 0 0 -2.5,2.5zm105.8,76l-101.1,0a0.2,0.2 0 0 1 -0.3,-0.3l0,-69.6a4.3,4.3 0 0 1 2,-3.4l0.1,-0.2l47.2,-44a4.4,4.4 0 0 1 4.7,0l45.7,44l0.2,0.2l0.1,0.2a3.5,3.5 0 0 1 1.5,2.7l0,70l0.1,0a0.2,0.2 0 0 1 -0.2,0.4z" />
                {!isCluster && (
                    <g className="smile">
                        <path d="m97.5,89a18.4,18.4 0 0 0 14.4,-7a2.5,2.5 0 0 0 -0.8,-3.7a2.5,2.5 0 0 0 -3.2,0.6a13.4,13.4 0 0 1 -20.1,0.7a2.5,2.5 0 0 0 -3.3,-0.4a2.5,2.5 0 0 0 -0.5,3.8a18.5,18.5 0 0 0 13.5,6z" />
                        <path d="m124,60.8a8.2,8.2 0 0 0 -8.3,8.2a3,3 0 1 0 6,0a2.3,2.3 0 1 1 4.5,-0.1l0,0.1a3,3 0 0 0 6,0a8.2,8.2 0 0 0 -8.3,-8.2l0.1,0z" />
                        <path d="m71.8,60.8a8.2,8.2 0 0 0 -8.2,8.2a3,3 0 1 0 6,0a2.3,2.3 0 1 1 4.4,-0.1l0,0.1a3,3 0 0 0 6,0a8.2,8.2 0 0 0 -8.2,-8.2z" />
                    </g>
                )}
                <path className="e" d="m39.5,124.7l0,0.3l-32,0a0.2,0.2 0 0 1 -0.3,-0.2l0,-68.8l32.2,-0.3l0.1,69z" />
                <path className="e" d="m41.5,49.1l-30.2,0.4l39,-39.2c0.7,-0.6 2.8,-2.4 7.1,-2.4l28.7,-0.6l-42.1,39.3a10.5,10.5 0 0 0 -2.5,2.5z" />
            </svg>
            {clusterNr && (
                <div className={styles.clusterNr + ' ' + (clusterNr > 99 ? styles.xSmall : ' ' + (clusterNr > 9 ? styles.small : ''))}>{clusterNr}</div>
            )}
        </div>
    );
};

export default HouseIcon;
